import { ContainerModule } from 'inversify'
import { TenantStore } from 'store/tenant'
import Types from '../../config/inversify.types'
import { TenantServiceImpl } from './tenant.service.impl'

export const TenantModule = new ContainerModule((bind) => {
    bind(Types.TenantService).to(TenantServiceImpl).inSingletonScope()
    bind(Types.TenantStore).to(TenantStore).inSingletonScope()
})
